import { createContext, useContext, useState, useEffect } from "react";
import { API } from "../api";

const GlobalPropertyContext = createContext(undefined);

export function GlobalPropertyProvider({ children }) {
  const [globalProperties, setGlobalProperties] = useState(null);
  const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function load() {
            try {
                const result = await API.get("dataSet?p:dataSet=globalWebSite");
                if (result) setGlobalProperties(result);
                else setGlobalProperties(null);
            } catch (err) {
                console.error("GlobalProperty error:", err);
            } finally {
                setLoading(false);
            }
        }
        load();
    }, []);

  return (<GlobalPropertyContext.Provider value={{ globalProperties, setGlobalProperties, loading }}>{children}</GlobalPropertyContext.Provider>);
}

export function useGlobalProperty() {
  const ctx = useContext(GlobalPropertyContext);
  if (!ctx) throw new Error("GlobalPropertyContext missing provider");
  return ctx;
}